/* eslint-disable no-nested-ternary */
import {
  Collapse,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import React, { Fragment } from "react";
import "./style.scss";
import { useTranslation } from "react-i18next";
import auth from "../../utils/auth";
import useWindowDimensions from "../../utils/dimension";

const ResponsiveDrawer = (props) => {
  const { t, i18n } = useTranslation();
  const { height } = useWindowDimensions();

  const {
    showSideBar,
    setShowSideBar,
    lists,
    setLists,
    redirect,
    logout,
  } = props;

  const handleLogout = () => {
    auth.logout();
  };

  const toggleExpandCollapse = (index, expand) => {
    const newLists = lists;
    newLists[index].isExpand = expand;
    setLists([...newLists]);
  };

  const onClickToRedirect = (link, name) => {
    redirect(link, name);
    setShowSideBar(false);
  };

  return (
    <Drawer
      PaperProps={{
        style: {
          backgroundColor: "#f4f5f7",
          marginTop: "64px",
          padding: "0 16px",
          width: "250px",
        },
      }}
      style={{ zIndex: 9998 }}
      anchor="left"
      open={showSideBar}
      onClose={() => {
        setShowSideBar(false);
      }}
    >
      <List style={{ height: `calc(${height}px - 86px)`, overflow: "auto" }}>
        {lists &&
          lists.length > 0 &&
          lists.map((listEle, index) => {
            if (listEle.text === "實時監測") {
              return (
                <Fragment key={listEle.text}>
                  <ListItem
                    button
                    className="side-bar-item"
                    onClick={() =>
                      onClickToRedirect(listEle.link, listEle.name)
                    }
                  >
                    <ListItemIcon>
                      {listEle.isActive
                        ? listEle.selectedIcon
                        : listEle.blackIcon}
                    </ListItemIcon>
                    <ListItemText
                      className={listEle.isActive ? "selected" : ""}
                      primary={t(listEle.text)}
                    />
                  </ListItem>
                  {/* <Divider /> */}
                </Fragment>
              );
            }
            return (
              <Fragment key={listEle.text}>
                <Divider key="d1" />
                <ListItem
                  button
                  className="side-bar-item"
                  onClick={() => {
                    if (listEle.link)
                      onClickToRedirect(listEle.link, listEle.name);
                  }}
                >
                  <ListItemIcon>
                    {listEle.isActive
                      ? listEle.selectedIcon
                      : listEle.blackIcon}
                  </ListItemIcon>
                  <ListItemText
                    className={listEle.isActive ? "selected" : ""}
                    primary={t(listEle.text)}
                  />
                  {listEle.children.length > 0 ? (
                    listEle.isExpand ? (
                      <IconButton
                        size="small"
                        onClick={(event) => {
                          event.stopPropagation();
                          toggleExpandCollapse(index, false);
                        }}
                      >
                        <ExpandLess />
                      </IconButton>
                    ) : (
                      <IconButton
                        size="small"
                        onClick={(event) => {
                          event.stopPropagation();
                          toggleExpandCollapse(index, true);
                        }}
                      >
                        <ExpandMore />
                      </IconButton>
                    )
                  ) : null}
                </ListItem>
                {listEle.children.length > 0 && (
                  <Collapse in={listEle.isExpand}>
                    <List>
                      {listEle.children
                        .map((children) => {
                          // HOT FIX : hiding some children in socif account
                          // showing some children in socif accounting
                          return (
                            <ListItem
                              key={children.text}
                              button
                              className="side-bar-item"
                              onClick={() =>
                                onClickToRedirect(children.link, children.name)
                              }
                            >
                              <ListItemIcon />
                              <ListItemText
                                className={children.isActive ? "selected" : ""}
                              >
                                {t(children.text)}
                              </ListItemText>
                            </ListItem>
                          );
                        })
                        .filter((ele) => !!ele)}
                    </List>
                  </Collapse>
                )}
              </Fragment>
            );
          })}
        {logout &&
          logout[0] &&
          logout.length > 0 &&
          logout.map((listEle, index) => {
            return (
              <Fragment key={`d${listEle.text}`} >
                <Divider/>

                <ListItem
                  key="logout"
                  button
                  className="side-bar-item"
                  onClick={handleLogout}
                >
                  <ListItemIcon>
                    {listEle.isActive
                      ? listEle.selectedIcon
                      : listEle.blackIcon}
                  </ListItemIcon>
                  <ListItemText
                    className={listEle.isActive ? "selected" : ""}
                    primary={t(listEle.text)}
                  />
                </ListItem>
              </Fragment>
            );
          })}
      </List>
    </Drawer>
  );
};

export default ResponsiveDrawer;
